/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CompetenzeMeseAnnoFattureOutputDto interface.
 */
export function instanceOfCompetenzeMeseAnnoFattureOutputDto(value) {
    return true;
}
export function CompetenzeMeseAnnoFattureOutputDtoFromJSON(json) {
    return CompetenzeMeseAnnoFattureOutputDtoFromJSONTyped(json, false);
}
export function CompetenzeMeseAnnoFattureOutputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mese': json['mese'] == null ? undefined : json['mese'],
        'anno': json['anno'] == null ? undefined : json['anno'],
        'ricavi': json['ricavi'] == null ? undefined : json['ricavi'],
        'fatture': json['fatture'] == null ? undefined : json['fatture'],
        'competenzaFatture': json['competenzaFatture'] == null ? undefined : json['competenzaFatture'],
        'risconto': json['risconto'] == null ? undefined : json['risconto'],
        'fde': json['fde'] == null ? undefined : json['fde'],
    };
}
export function CompetenzeMeseAnnoFattureOutputDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'mese': value['mese'],
        'anno': value['anno'],
        'ricavi': value['ricavi'],
        'fatture': value['fatture'],
        'competenzaFatture': value['competenzaFatture'],
        'risconto': value['risconto'],
        'fde': value['fde'],
    };
}
